export class CPhotoGalerySearchModel{
    fPhotoGaleryGroupId? : number;
}